<li class="item">
    <div class="item__header" [class.item__header--open]="isOpen" (click)="isOpen = !isOpen">
        <div class="item__header__text" [innerHTML]="data.heading.value" tabindex="0" (keyup.enter)="isOpen = !isOpen"></div>
        <div class="item__header__toggle" [class.item__header__toggle--open]="isOpen" [class.item__header__toggle--closed]="!isOpen"></div>
    </div>
    <div class="item__content html" *ngIf="isOpen">
        <xhtmlstring [data]="data.mainBody"></xhtmlstring>
    </div>
</li>
